const outDelay = 500;

let $toast;

const delays = {
    slow: 10000,
    medium: 4500,
    fast: 2000,
};


function _assertToastElement() {
    if ($toast) {
        return;
    }

    $toast = document.createElement('div');
    $toast.classList.add('toast');

    let $messageContainer = document.createElement('p');
    $messageContainer.classList.add('message');

    $toast.appendChild($messageContainer);
    document.querySelector('body').appendChild($toast);

    $toast.$messageContainer = $messageContainer;
}


function toast(message, delay) {
    _assertToastElement();

    if ($toast.classList.contains('onscreen')) {
        $toast.classList.remove('onscreen');
        window.setTimeout(() => {
            toast(message, delay);
        }, outDelay);
        return;
    }

    $toast.$messageContainer.innerHTML = message;
    $toast.classList.add('onscreen');

    window.setTimeout(() => {
        $toast.classList.remove('onscreen');
    }, delay || delays.medium);
}

export {
    delays,
    toast
}